export default __webpack_public_path__ + "static/media/FSDillonProBold.f3410e3b.otf";